import { Monitor, Moon, Sun } from 'lucide-react-native'
import React from 'react'
import { Pressable, View } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { ThemeMode } from '../../theme'

export function ThemeSwitcher({ compact = false }: { compact?: boolean }) {
  const { theme, themeMode, setThemeMode } = useThemeValue()
  const items: { mode: ThemeMode; icon: React.ComponentType<any> }[] = [
    { mode: 'light', icon: Sun },
    { mode: 'dark', icon: Moon },
    { mode: 'system', icon: Monitor },
  ]

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme.colors.surface,
        borderWidth: 1,
        borderColor: theme.colors.border,
        borderRadius: 999,
        padding: 4,
        gap: 4,
      }}
    >
      {items.map(item => {
        const Icon = item.icon
        const active = themeMode === item.mode

        return (
          <Pressable
            key={item.mode}
            onPress={() => setThemeMode(item.mode)}
            style={{
              width: compact ? 34 : 36,
              height: compact ? 34 : 36,
              borderRadius: 999,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: active ? theme.colors.background : 'transparent',
            }}
          >
            <Icon color={active ? theme.colors.text : theme.colors.inactive} size={16} />
          </Pressable>
        )
      })}
    </View>
  )
}
